import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from '../../core/service'

export const getDetailData = createAsyncThunk(
  'portfolioInsights/common/getDetailData',
  async ({ path, params }, { rejectWithValue }) => {
    try {
      const response = await Service.getDetailData({ path, params })
      if (response.success) {
        return response
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
